import type { MergePeriodDto, MergeRowDto } from '../api/mergeResolution.types';

import type { CellKey } from './types';

export const CELL_KEY_SEPARATOR = String.fromCharCode(0x1f);

export function cellKey(inputRowId: string, dateId: string | null): CellKey {
  return `${inputRowId}${CELL_KEY_SEPARATOR}${dateId ?? ''}` as CellKey;
}

export function parseCellKey(key: CellKey): {
  inputRowId: string;
  dateId: string | null;
} {
  const firstSeparatorIndex = key.indexOf(CELL_KEY_SEPARATOR);
  const inputRowId = key.slice(0, firstSeparatorIndex);
  const dateSegment = key.slice(firstSeparatorIndex + 1);
  return {
    inputRowId,
    dateId: dateSegment === '' ? null : dateSegment,
  };
}

export function periodKey(row: MergeRowDto, period: MergePeriodDto): CellKey {
  return cellKey(row.Input_RowID, period.DateID);
}
